import Vue from 'vue'
import VRadioGroup from 'vuetify/es5/components/VRadioGroup'
import Vuetify, {
  VAlert,
  VApp,
  VAvatar,
  VBtn,
  VCard,
  VCheckbox,
  VDatePicker,
  VDialog,
  VDivider,
  VFooter,
  VForm,
  VIcon,
  VImg,
  VList,
  VMenu,
  VNavigationDrawer,
  VSelect,
  VSnackbar,
  VSwitch,
  VTabs,
  VTextarea,
  VTextField,
  VToolbar,
  VTooltip,
} from 'vuetify/lib'
import transitions from 'vuetify/lib/components/transitions'

Vue.use(Vuetify, {
  theme: {
    primary: '#FFAA00',
    secondary: '#9270f6',
    accent: '#297ee1',
    error: '#EF6D67',
    info: '#2196F3',
    success: '#55AD9A',
    warning: '#FFC107',
    slate050: '#F4F6F9',
    slate100: '#E9ECEF',
    slate200: '#C9D1D8',
    slate300: '#93A3B2',
    slate400: '#495159',
    green: '#55AD9A',
  },
  components: {
    VApp,
    VAvatar,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VMenu,
    VForm,
    VIcon,
    VTextField,
    VTextarea,
    VSelect,
    VSwitch,
    VCheckbox,
    VToolbar,
    VRadioGroup,
    VAlert,
    VSnackbar,
    VDivider,
    VCard,
    VDatePicker,
    VImg,
    VTooltip,
    VTabs,
    VDialog,
    transitions,
  },
})
